import { Product } from "../../services";

export const SUPPORT_PORTAL_URL = "https://remotesupport.tylertech.com/";

export function productSupportUrl(product: string): string
{
    return product === Product.InfiniteVisions
        ? "https://www.tylertech.com/client-support/school-erp-pro-support"
        : "https://www.tylertech.com/client-support/erp-pro-support";
}
